"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBonusesByTag = void 0;
var bonuses_1 = require("../bonuses");
var react_1 = require("react");
var useBonusesByTag = function (tag) {
    var _a = (0, bonuses_1.useAllBonuses)(), data = _a.data, isLoading = _a.isLoading;
    return (0, react_1.useMemo)(function () { return ({
        bonuses: (data === null || data === void 0 ? void 0 : data[tag]) || [],
        isLoading: isLoading,
    }); }, [data, tag, isLoading]);
};
exports.useBonusesByTag = useBonusesByTag;
